import React from 'react';
import PropTypes from 'prop-types';
import { MenuItem, SplitButton } from 'react-bootstrap/lib';
import { Permissions } from '@upstart/harmony/lib/constants';
import { disableChangePasswordFunctionality } from 'util/utils';
import withUserPermission from './userPermission';
import DeleteButton from './DeleteButton';
import UnlockButton from './UnlockButton';

function EmployeeEditButton({ user, history, onDelete, onUnlock }) {
  // currentUser should have access to all the roles of 'user'
  if (user.isAccessible) {
    return (
      <div>
        <SplitButton
          title="Edit"
          key={user.id}
          id={`split-button-basic-${user.id}`}
          onClick={() => history.push(`/employees/user/${user.id}/edit`)}
        >
          <MenuItem
            onClick={() => history.push(`/employees/user/${user.id}/access`)}
          >
            Dealership Access
          </MenuItem>
          <MenuItem
            disabled={disableChangePasswordFunctionality()}
            onClick={() =>
              history.push(`/employees/user/${user.id}/changePassword`)
            }
          >
            Change Password
          </MenuItem>
          <UnlockButton user={user} onUnlock={onUnlock} />
          <DeleteButton user={user} onDelete={onDelete} />
        </SplitButton>
      </div>
    );
  }
  return <div />;
}

EmployeeEditButton.propTypes = {
  user: PropTypes.object,
  history: PropTypes.object,
  onDelete: PropTypes.func,
  onUnlock: PropTypes.func,
};

export default withUserPermission(Permissions.UPDATE)(EmployeeEditButton);
